import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({

  state: {
    // loggedIn: false,
    videos: []
  },
  getters: {
    // isLoggedIn: state => {
    //   return state.loggedIn
    // },
    getVideos: state => {
      return state.videos
    }
  },
  mutations: {
    addVideos: (state, payload) => {
      state.videos = payload
    },
    addVideo: (state, payload) => {
      if (!state.videos) {
        state.videos = {}
      }
      // state.videos.push(payload);
      state.videos[payload.key] = payload.value
    },
    deleteVideo: (state, key) => {
      console.log('mutations.deleteVideo key = ' + key)
      delete state.videos[key]
    }

  },
  actions: {
    login: (context, payload) => {
      context.commit('login', payload)
    },
    logout: context => {
      context.commit('logout')
    }
  }

})



// WEBPACK FOOTER //
// ./src/store/index.js